<section class="install-card" [style.--brand]="themeColor">
  <div class="handle"></div>

  <button type="button" class="close" aria-label="Close" (click)="later()">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="M7 7l10 10M17 7L7 17" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
    </svg>
  </button>

  <div class="app-icon">
    <img *ngIf="logo && !logoFailed" [src]="logo" [alt]="appName" (error)="logoFailed = true" />
    <span *ngIf="!logo || logoFailed">{{ initial }}</span>
  </div>

  <div class="badge">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path fill="currentColor" d="M12 2l1.2 6.2L19 9.5l-5.8 1.3L12 17l-1.2-6.2L5 9.5l5.8-1.3L12 2z"/>
    </svg>
    Install the app
  </div>

  <h2>Your passbook, one tap away</h2>
  <p class="subtitle">{{ subtitle }}</p>

  <ol *ngIf="showSteps" class="steps">
    <li *ngFor="let step of steps">{{ step }}</li>
  </ol>

  <div class="home-preview" *ngIf="!showSteps">
    <div class="preview-top">
      <span>9:41</span>
      <span class="preview-label">Home screen</span>
      <span class="preview-dots" aria-hidden="true"></span>
    </div>

    <div class="apps">
      <div class="mini">
        <span class="glyph chat">
          <svg viewBox="0 0 24 24"><path fill="currentColor" d="M5 6.5A2.5 2.5 0 0 1 7.5 4h9A2.5 2.5 0 0 1 19 6.5v7A2.5 2.5 0 0 1 16.5 16H9l-3.2 2.4c-.5.4-1.3 0-1.3-.7V6.5z"/></svg>
        </span>
        <span>Chat</span>
      </div>
      <div class="mini">
        <span class="glyph photos">
          <svg viewBox="0 0 24 24"><path fill="currentColor" d="M8 5h2.2l1-1.5h1.6L14 5H16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2zm4 10.2A3.2 3.2 0 1 0 12 8.8a3.2 3.2 0 0 0 0 6.4z"/></svg>
        </span>
        <span>Photos</span>
      </div>
      <div class="mini featured">
        <span class="new">New</span>
        <span class="glyph brand">
          <img *ngIf="logo && !logoFailed" [src]="logo" alt="" />
          <span *ngIf="!logo || logoFailed">{{ initial }}</span>
        </span>
        <span>{{ shortName }}</span>
      </div>
      <div class="mini">
        <span class="glyph music">
          <svg viewBox="0 0 24 24"><path fill="currentColor" d="M9 17.5a2.5 2.5 0 1 1-2-2.45V7.2l9-1.6v8.4a2.5 2.5 0 1 1-2-2.45V8.2l-5 1v8.3z"/></svg>
        </span>
        <span>Music</span>
      </div>
      <div class="mini">
        <span class="glyph maps">
          <svg viewBox="0 0 24 24"><path fill="currentColor" d="M12 3.5a6 6 0 0 1 6 6c0 4.2-6 11-6 11s-6-6.8-6-11a6 6 0 0 1 6-6zm0 8.2a2.2 2.2 0 1 0 0-4.4 2.2 2.2 0 0 0 0 4.4z"/></svg>
        </span>
        <span>Maps</span>
      </div>
    </div>
  </div>

  <div class="actions">
    <button type="button" class="later" (click)="later()">Maybe later</button>
    <button type="button" class="install" (click)="install()">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 4a1 1 0 0 1 1 1v8.2l2.3-2.3a1 1 0 1 1 1.4 1.4l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 1 1 1.4-1.4L11 13.2V5a1 1 0 0 1 1-1zM6 18a1 1 0 0 1 1-1h10a1 1 0 1 1 0 2H7a1 1 0 0 1-1-1z"/>
      </svg>
      {{ installLabel }}
    </button>
  </div>
</section>
